import {gql} from "@irati/utils/gql"

export default gql`
  fragment fullBranding on Branding {
    uuid
    businessId
    teamId
    businessLogoUrl
    businessSquareLogoUrl
    hasPartnerLogo
    ssoBrandingEnabled
    isEnabled
    primaryColour
    textColour
    welcomeEmail
  }
`
